import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  detailsLink: {
    textDecoration: 'none',
    color: 'blue'
  },

  detailsTitleContainer: {
    height: '60px',
    overflow: 'auto',
    overflowX: 'hidden',
    marginBottom: '10px',
  },

  detailsDescriptionContainer: {
    height: '80px',
    overflow: 'auto',
    overflowX: 'hidden',
  },

  detailsCardActionContainer: {
    justifyContent: 'right',
  },

  detailsCardActionEditIcon: {
    cursor: 'pointer',
  },

  detailsCardActionEditDeleteIcon: {
    cursor: 'pointer',
  },

  likeBlue: {
    color: 'blue',
    cursor: 'pointer',
  },

  likeBlack: {
    color: 'black',
    cursor: 'pointer',
  },
}));
